import React from "react";
import QuestionCard from "./QuestionCard/QuestionCard";

const Preguntas = () => {
  return (
    <div>
      <QuestionCard />
    </div>
  );
};

export default Preguntas;
